module.exports = __webpack_public_path__ + "static/media/menu-5.08e89049.png";